import { FaArrowRight } from "react-icons/fa";

import { Rating } from "./Rating";

import {
  Container,
  Photo,
  Content,
  Title,
  Message,
  RatingContainer,
  Position,
  NextButton,
} from "./styles";

export function Testimonial({
  testimonial: { photo, title, message, rating },
  position,
  total,
  onClickNext,
  showNext,
}) {
  return (
    <Container>
      <Photo src={photo} alt="" />
      <Content>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <RatingContainer>
          <Rating value={rating || 0} />
        </RatingContainer>
        <Position>
          {position}/{total}
        </Position>
      </Content>
      {showNext && (
        <NextButton onClick={onClickNext}>
          <FaArrowRight />
        </NextButton>
      )}
    </Container>
  );
}